import { createListenerMiddleware } from '@reduxjs/toolkit';
import { _pickDevice } from 'console/redux/devices/selected-id/index';
import { deActivateZTHDashboard } from 'console/dashboards/zth/actions';
import { leaveFromDashboard } from 'console/dashboards/z3k/actions';
import { clearEventOnMap, pickDevice } from 'console/redux/main-actions';
import { exitMapDashboard } from 'console/pages/dashboard.map/model/store';
import { set_ui_settings } from 'console/redux/settings-actions';
export const listenerMiddlewareSelectedDevice = createListenerMiddleware();
listenerMiddlewareSelectedDevice.startListening({
    actionCreator: _pickDevice,
    effect: (action, listenerApi) => {
        if (action.payload != null) {
            // @ts-ignore
            listenerApi.dispatch(deActivateZTHDashboard());
            // @ts-ignore
            listenerApi.dispatch(leaveFromDashboard());
            listenerApi.dispatch(exitMapDashboard());
            // @ts-ignore
            listenerApi.dispatch(clearEventOnMap());
            // @ts-ignore
            listenerApi.dispatch(set_ui_settings({ selected_device_id: action.payload }));
        }
    },
});
export const listenerMiddlewareDeleteSelectedDevice = createListenerMiddleware();
listenerMiddlewareDeleteSelectedDevice.startListening({
    type: 'DEVICE_DELETED',
    effect: (action, listenerApi) => {
        const state = listenerApi.getState();
        if (state.devices.selected_id === action.device_id) {
            listenerApi.dispatch(pickDevice(state.devices.items[0].id || null));
        }
    },
});
